import React, { useState } from 'react';
import "../../assets/style/Fonction.css";

interface FiltersProps {
  setFiltered: (filteredMovies: string) => void;
}

const Filters: React.FC<FiltersProps> = ({ setFiltered }) => {
  const [activeFilter, setActiveFilter] = useState('all');

  const handleFilterClick = (filter: string) => {
    setActiveFilter(filter);
    setFiltered(filter);
  };

  return (
    <div>
      <h2 data-heading="Mes projets" className="section__title">
        Récent travail
      </h2>

      <div className="work__filters">
        <span
          className={`work__item ${activeFilter === 'all' ? 'active-work' : ''}`}
          onClick={() => handleFilterClick('all')}
          data-filter="all"
        >
          Tous
        </span>
        <span
          className={`work__item ${activeFilter === 'web' ? 'active-work' : ''}`}
          onClick={() => handleFilterClick('web')}
          data-filter=".web"
        >
          Web
        </span>
        <span
          className={`work__item ${activeFilter === 'app' ? 'active-work' : ''}`}
          onClick={() => handleFilterClick('app')}
          data-filter=".app"
        >
          App
        </span>
        <span
          className={`work__item ${activeFilter === 'design' ? 'active-work' : ''}`}
          onClick={() => handleFilterClick('design')}
          data-filter=".design"
        >
          Design
        </span>
      </div>
    </div>
  );
};

export default Filters;
